import React, { Component } from "react";
import PropTypes from "prop-types";
import AutoSuggest from "./AutoSuggest.js";
import "./AddAction.css";

function validateEmail(email) {
  var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(String(email).toLowerCase());
}

class AddAction extends Component {
  constructor() {
    super();

    this.state = {
      nameValue: "",
      emailValue: "",
      actionTextValue: "",
      error: "",
    };
  }

  componentDidMount = () => {
    //using componentDidMount because the internet told me to set state there :)
    var prepopulatedNameValue = "";
    var prepopulatedEmailValue = "";
    var prepopulatedActionTextValue = "";
    if (this.props.concern.action) {
      prepopulatedActionTextValue = this.props.concern.action.actionText;
    }
    if (this.props.concern.action && this.props.concern.action.memberId) {
      for (let member of this.props.members) {
        if (member.id === this.props.concern.action.memberId) {
          prepopulatedNameValue = member.name;
          prepopulatedEmailValue = member.email;
        }
      }
    }

    this.setState({
      nameValue: prepopulatedNameValue,
      emailValue: prepopulatedEmailValue,
      actionTextValue: prepopulatedActionTextValue,
    });

    let concern = this.props.concern;
    window.analytics.track("Opens Add Action Popup", {
      concernText: concern.concernText,
      reporter: concern.reporter,
      plusOnesCount: concern.plusOnes,
      actionMemberId: concern.action ? concern.action.memberId : null,
      actionText: concern.action ? concern.action.actionText : null,
    });
  };

  commitNameOrEmailValue = (field, value) => {
    if (field !== "nameValue" && field !== "emailValue") {
      console.error("something about the field name doesn't look right");
      return false;
    }

    this.setState({
      [field]: value,
      error: "",
    });
  };

  handleChangeActionText = event => {
    var actionTextValue = event.target.value;

    this.setState({
      actionTextValue: actionTextValue,
    });
  };

  checkForEmailErrors = () => {
    if (!this.state.emailValue) {
      return false;
    } else if (!validateEmail(this.state.emailValue)) {
      this.setState({
        error: "That email doesn't look real. Try again?",
      });
      return true;
    }
    return false;
  };

  checkForNameButNoEmail = () => {
    if (this.state.nameValue && !this.state.emailValue) {
      this.setState({
        error: "Can you provide an email address too?",
      });
      return true;
    }
    return false;
  };

  buildActionObject = () => {
    var memberId;
    var actionObject;
    for (let member of this.props.members) {
      if (member.email === this.state.emailValue) {
        memberId = member.id;
        actionObject = {
          memberId: memberId,
          actionText: this.state.actionTextValue,
        };
        return actionObject;
      }
    }

    if (this.state.emailValue) {
      memberId = Date.now();
      this.props.commitNewMember(
        this.state.nameValue,
        this.state.emailValue,
        memberId
      );

      actionObject = {
        memberId: memberId,
        actionText: this.state.actionTextValue,
      };
      return actionObject;
    } else {
      actionObject = {
        memberId: null,
        actionText: this.state.actionTextValue,
      };
      return actionObject;
    }
  };

  handleAddActionClick = event => {
    event.preventDefault();

    if (this.checkForEmailErrors()) {
      return false;
    } else if (this.checkForNameButNoEmail()) {
      return false;
    }

    this.props.commitEditedConcern(
      this.props.concernIndex,
      "action",
      this.buildActionObject()
    );

    this.props.openCloseActionModal(false, -1);

    let concern = this.props.concern;
    window.analytics.track("Adds an Action", {
      concernText: concern.concernText,
      reporter: concern.reporter,
      plusOnesCount: concern.plusOnes,
      actionMemberId: concern.action ? concern.action.memberId : null,
      actionText: concern.action ? concern.action.actionText : null,
    });
  };

  render() {
    return (
      <form className="form-container">
        <h1 className="modal-title">Add Owner</h1>
        <p>Assign this concern an owner. They'll get an email reminder.</p>
        <AutoSuggest
          nameValue={this.state.nameValue}
          emailValue={this.state.emailValue}
          commitNameOrEmailValue={this.commitNameOrEmailValue}
          members={this.props.members}
          commitNewMember={this.props.commitNewMember}
        />
        <div className="email-error">{this.state.error}</div>
        <div className="action-container editable-container">
          <textarea
            className="editable-input"
            placeholder="How can this concern be resolved?"
            value={this.state.actionTextValue}
            onChange={this.handleChangeActionText}
          />
        </div>
        <div className="action-button-container">
          <div
            className="action-button"
            onClick={event => this.handleAddActionClick(event)}
            onKeyPress={event => {
              if (event.key === "Enter") {
                this.handleAddActionClick(event);
              }
            }}
            tabIndex="0"
          >
            Add Owner
          </div>
        </div>
      </form>
    );
  }
}

AddAction.propTypes = {
  openCloseActionModal: PropTypes.func.isRequired,
  members: PropTypes.array,
  commitNewMember: PropTypes.func.isRequired,
  concernIndex: PropTypes.number,
  concern: PropTypes.shape({
    id: PropTypes.number.isRequired,
    concernText: PropTypes.string,
    reporter: PropTypes.string,
    assignee: PropTypes.string,
    plusOnes: PropTypes.number.isRequired,
    createdAt: PropTypes.number.isRequired,
    status: PropTypes.oneOf(["open", "queued", "completed"]),
    userId: PropTypes.string.isRequired,
  }),
  commitEditedConcern: PropTypes.func.isRequired,
};

export default AddAction;



// WEBPACK FOOTER //
// ./src/components/AddAction.js